import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'vc-sprite-icons',
  templateUrl: './icons.component.html',
  styleUrls: ['./icons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconsComponent implements OnInit {
  @Input()
  name: string;

  public spriteSvgPath = `${environment.svgSpritePath}?v=3#`;

  constructor() {}

  ngOnInit() {}
}
